import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-primary/20">
      <SliderPrimitive.Range className="absolute h-full bg-primary" />
    </SliderPrimitive.Track>

    {/* MIN THUMB */}
    <SliderPrimitive.Thumb
      className="block h-5 w-5 rounded-full border-2 border-[#8C6A3E] bg-[#EAD7CF] shadow-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#B08D57]"
    />

    {/* MAX THUMB */}
    <SliderPrimitive.Thumb
      className="block h-5 w-5 rounded-full border-2 border-[#8C6A3E] bg-[#EAD7CF] shadow-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#B08D57]"
    />
  </SliderPrimitive.Root>
))

Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }